import { makeStyles } from 'tss-react/mui';

import { CHAINS_PAGE_WIDTH } from 'modules/chains/constants';

const name = 'AdvancedApiPage';

export const useAdvancedApiPageStyles = makeStyles({ name })(() => ({
  content: {
    maxWidth: CHAINS_PAGE_WIDTH,
  },
}));
